module.exports = __webpack_public_path__ + "static/media/twitter.a7df40bb.svg";